import { StateCreator } from "zustand";
import { DocumentsStore } from "@/services/stores/types";

export const documentsStore: StateCreator<DocumentsStore> = set => ({
  documents: null,
  setDocuments: documents => set(() => ({ documents })),
});
